<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok"
           :width="680"
           :loading="loading" @on-cancel="cancel"
           class="mask long-modal">
      <h3 slot="header" class="modal-header">预估GOP详情</h3>
      <div v-if="data">
        <div class="bold mb8">当日GOP:{{data.gopValue}}</div>
        <div class="mul">
          <div v-for="item in apidata">{{item}}</div>
          <!--          <div>服务费收入:</div>-->
          <!--          <div>预估成本:</div>-->
          <!--          <div>税率系数:</div>-->
          <!--          <div></div>-->

        </div>


      </div>
    </Modal>
  </div>


</template>
<script>
  import {formulaSnapshotdetail} from "../../../../../api/gop";

  export default {
    name: "",
    components: {},
    props: {
      n: {
        type: Number,
        default: 0
      },
      data: {
        type: Object,
        default: null
      }

    },
    watch: {
      n() {
        this.apidata = []
        formulaSnapshotdetail({
          snapShotFid:this.data.formulaSnapshotFid

        }).then(res => {
          if (!res.data) {
            return
          }
          this.apidata = res.data

        }).catch(error => {
        })
        this.isShow = true
      }
    },
    data() {
      return {
        apidata: [],
        loading: false,
        isShow: false,
      }
    },
    methods: {
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
      },
      cancel() {

      }
    }

  }
</script>

<style scoped>
  .mul div {
    width: 45%;
    display: inline-block;
    margin-bottom: 8px;
    vertical-align: top;
    /* width: 100%; */
  }

</style>
